import { Star } from "lucide-react";

export function Stars({ value = 0, size = 14, className = "" }) {
  const rounded = Math.round(value);
  return (
    <span
      className={`inline-flex items-center gap-0.5 ${className}`}
      aria-label={`${rounded} de 5 estrelas`}
    >
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          size={size}
          fill={i <= rounded ? "currentColor" : "none"}
          className={i <= rounded ? "text-amber-400" : "text-white/25"}
        />
      ))}
    </span>
  );
}

export function RatingBadge({ value = 0, count = 0, size = 13, testid }) {
  if (!count) return null;
  return (
    <span className="inline-flex items-center gap-1.5 text-xs text-mute" data-testid={testid}>
      <Stars value={value} size={size} />
      <span>
        {Number(value).toFixed(1).replace(".", ",")} ({count})
      </span>
    </span>
  );
}
